"use client";

import { useId, useMemo } from "react";
import AdsProvider from "./AdsProvider";
import FeedAdSlot from "./FeedAdSlot";

export default function SingleAdSlot({ enabled = true, placementId }) {
  const reactId = useId();
  const opportunity = useMemo(() => ({
    opportunityId: `${placementId}-${reactId.replace(/[^a-z0-9_-]/gi, "")}`,
    placementId,
    sequence: 0,
  }), [placementId, reactId]);

  if (!enabled || !placementId) return null;

  return (
    <AdsProvider enabled placementId={placementId}>
      <FeedAdSlot opportunity={opportunity} />
    </AdsProvider>
  );
}
